import React, { Fragment } from 'react';
import shortid from 'shortid';
import crypto from 'crypto';
import PropTypes from 'prop-types';
import { spmfcloudFunctionUrl } from '../../../actions/salesforces';

/* Encrypt for attachement */
const encrypt = (text, publicKey) => {
    const buffer = Buffer.from(`${text}{and}${new Date().getTime()}`);
    const encrypted = crypto.publicEncrypt(publicKey, buffer);
    return encrypted.toString('base64');
};

const BeneficiaryAttachment = props => (
    <div className="row">
        <div className="card">
            <div className="x_title">
                <h4>Attachment </h4>
                <div className="clearfix" />
            </div>
            {props.attachmentList.map(attachment => (
                <div className="row" key={shortid.generate()}>
                    <div className="col-lg-3 col-md-3 col-xs-6" style={{ textAlign: 'center' }}>
                        <i className="fa fa-file fa-2x" />
                    </div>
                    <div className="col-lg-9 col-md-9 col-xs-6">
                        <a 
                            href="#"
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={(e) => {
                                e.preventDefault();
                                const form = document.createElement('form');
                                form.setAttribute('method', 'post');
                                form.setAttribute('target', '_blank');
                                form.setAttribute('accept-charset', 'utf-8');
                                const attachmentId = encrypt(attachment.Id, props.publicKey);
                                form.setAttribute('action', `${spmfcloudFunctionUrl}/get/attachment`);
                                const token = document.createElement('input');
                                token.setAttribute('type', 'hidden');
                                token.setAttribute('value', props.token);
                                token.setAttribute('name', 'token');
                                form.appendChild(token);
                                const id = document.createElement('input');
                                id.setAttribute('type', 'hidden');
                                id.setAttribute('value', attachmentId);
                                id.setAttribute('name', 'id');
                                form.appendChild(id);
                                document.getElementById('hidden').append(form);
                                form.submit();
                            }}
                        >
                            <p>{attachment.Name} <br /> ({(attachment.BodyLength / 1024).toFixed(2)} KB) </p>
                            <p>{attachment.Description}</p>
                        </a>
                    </div>
                </div>
            ))}
            {props.userType !== null ?
                <Fragment>
                    <div className="row">
                        <h5>Supporting documents for appeal :</h5>
                    </div>
                    {props.newAttachments.map((newFile, idx) => (
                        <div className="row" key={shortid.generate()}>
                            <div className="col-lg-9 col-md-9 col-xs-6" style={{ textAlign: 'left' }}>
                                <i className="fa fa-file fa-2x" /> &nbsp;{newFile.Name}
                            </div>
                            <div className="col-lg-3 col-md-3 col-xs-6">
                                <i
                                    onClick={props.onRemove}
                                    id={`removeAttachment${idx}`}
                                    className="fa fa-times-circle fa-2x"
                                    role="button"
                                />
                            </div>
                        </div>
                    ))}
                    <br />
                    <div className="row">
                        <div className="col-lg-6">
                            <i className="fa fa-upload fa-2x btn-i" style={{ cursor: 'pointer' }}>
                                <input
                                    onClick={(e) => { e.target.value = null; }}
                                    onChange={props.onUpload}
                                    type="file"
                                    className="form-control-file"
                                    aria-describedby="fileHelp1"
                                />
                            </i>
                        </div>
                        <div className="col-lg-6">
                            <i
                                className="fa fa-save fa-2x btn-i"
                                style={{ cursor: 'pointer' }}
                                onClick={props.onSaveUpload}
                            />
                        </div>
                    </div>
                </Fragment> : null}
        </div>
    </div>

);


BeneficiaryAttachment.propTypes = {
    attachmentList: PropTypes.array,
    token: PropTypes.string,
    onUpload: PropTypes.func,
    newAttachments: PropTypes.array,
};

BeneficiaryAttachment.defaultProps = {
    attachmentList: [],
    token: '',
    onUpload: () => { },
    newAttachments: [],
};

export default BeneficiaryAttachment;



//////////////////
// WEBPACK FOOTER
// ./src/components/Portal/Beneficiary/BeneficiaryAttachment.js
// module id = 893
// module chunks = 0